<template>
    <div class="information-content">
      <div>
        <div style="width: 100%;margin-top: 10px">
          <el-row>
            <el-col :span="2">
              <el-row>
                <el-col :span="24">
                  <div class="tool">
                    <el-popover
                      placement="bottom"
                      title=""
                      width="50"
                      trigger="click"
                      v-model="visible"
                    >
                      <div style="text-align: center; margin: 0">
                        <el-button  size="mini" @click="addjizu" round>添加机组</el-button>
                      </div>
                      <el-button slot="reference"  size="mini">冷水机组</el-button>
                    </el-popover>
                  </div>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="18">
              <el-form ref="form" :model="form" label-width="100px" size="mini">
                <el-row >
                  <el-col :span="24">
                    <el-col :span="1">
                      <el-form-item label="">
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="类型" class="item">
                        <el-select v-model="tipData" placeholder="请选择">
                          <el-option
                            v-for="item in tipArray"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="品牌" class="item">
                        <el-input v-model="form.name">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="型号" class="item">
                        <el-input v-model="form.name">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="冷量" class="item">
                        <el-input v-model="form.name">
                          <template slot="append">m³/h</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-col>
                </el-row>
                <el-row v-for="(items , index) in form.airArray" :key="index">
                  <el-col :span="24">
                    <el-col :span="1">
                      <el-form-item label="">
                      </el-form-item>
                    </el-col>
                    <!--<el-col :span="2">
                      <el-form-item :label="`机组${index + 1}`" class="item">
                      </el-form-item>
                    </el-col>-->
                    <el-col :span="5">
                      <el-form-item label="类型" class="item">
                        <el-select v-model="items.tipData" placeholder="请选择">
                          <el-option
                            v-for="item in tipArray"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="品牌" class="item">
                        <el-input v-model="items.name">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="型号" class="item">
                        <el-input v-model="items.name">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="冷量" class="item">
                        <el-input v-model="items.name">
                          <template slot="append">m³/h</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="1">
                      <el-form-item label="" class="item">
                        <i class="el-icon-delete" style="cursor: pointer" @click="deleteItem(items, index)"></i>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-col>
                </el-row>
              </el-form>
            </el-col>
          </el-row>
        </div>
        <div style="border-top: 1px solid #e8e8e8;width: 100%;height: 1px"></div>
        <div style="width: 100%;margin-top: 10px">
          <el-row>
            <el-col :span="2">
              <el-row>
                <el-col :span="24">
                  <div class="tool">
                    <el-popover
                      placement="bottom"
                      title=""
                      width="50"
                      trigger="click"
                    >
                      <!--// 品牌 型号 功率 流量 拖动方式 -->
                      <div style="text-align: center; margin: 0">
                        <el-button  size="mini" @click="addjizu" round>添加机组</el-button>
                      </div>
                      <el-button slot="reference"  size="mini">冷冻水循环泵</el-button>
                    </el-popover>
                  </div>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="18">
              <el-form ref="form" :model="form" label-width="100px" size="mini" >
                <el-row >
                  <el-col :span="24">
                    <el-col :span="1">
                      <el-form-item label="">
                      </el-form-item>
                    </el-col>

                    <el-col :span="4">
                      <el-form-item label="品牌" class="item">
                        <el-input v-model="form.name">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="4">
                      <el-form-item label="型号" class="item">
                        <el-input v-model="form.name">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="功率" class="item">
                        <el-input v-model="form.name">
                          <template slot="append">kwh</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="流量" class="item">
                        <el-input v-model="form.name">
                          <template slot="append">m³/h</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="4">
                      <el-form-item label="拖动方式" class="item">
                        <el-select v-model="tipData" placeholder="请选择">
                          <el-option
                            v-for="item in tipArray"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-col>
                </el-row>
                <el-row v-for="(items , index) in form.airArray" :key="index">
                  <el-col :span="24">
                    <el-col :span="1">
                      <el-form-item label="">
                      </el-form-item>
                    </el-col>
                    <!--<el-col :span="2">
                      <el-form-item :label="`机组${index + 1}`" class="item">
                      </el-form-item>
                    </el-col>-->
                    <el-col :span="5">
                      <el-form-item label="类型" class="item">
                        <el-select v-model="items.tipData" placeholder="请选择">
                          <el-option
                            v-for="item in tipArray"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="品牌" class="item">
                        <el-input v-model="items.name">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="型号" class="item">
                        <el-input v-model="items.name">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="冷量" class="item">
                        <el-input v-model="items.name">
                          <template slot="append">m³/h</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="1">
                      <el-form-item label="" class="item">
                        <i class="el-icon-delete" style="cursor: pointer" @click="deleteItem(items, index)"></i>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-col>
                </el-row>
              </el-form>
            </el-col>
          </el-row>
        </div>
        <div style="border-top: 1px solid #e8e8e8;width: 100%;height: 1px"></div>
        <div style="width: 100%;margin-top: 10px">
          <el-row>
            <el-col :span="2">
              <el-row>
                <el-col :span="24">
                  <div class="tool">
                    <el-popover
                      placement="bottom"
                      title=""
                      width="50"
                      trigger="click"
                    >
                      <!--// 品牌 型号 功率 流量 拖动方式 -->
                      <div style="text-align: center; margin: 0">
                        <el-button  size="mini" @click="addjizu" round>添加机组</el-button>
                      </div>
                      <el-button slot="reference"  size="mini">冷冻水循环泵</el-button>
                    </el-popover>
                  </div>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="18">
              <el-form ref="form" :model="form" label-width="100px" size="mini">
                <el-row >
                  <el-col :span="24">
                    <el-col :span="1">
                      <el-form-item label="">
                      </el-form-item>
                    </el-col>
                    <el-col :span="4">
                      <el-form-item label="品牌" class="item">
                        <el-input v-model="form.name">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="4">
                      <el-form-item label="型号" class="item">
                        <el-input v-model="form.name">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="功率" class="item">
                        <el-input v-model="form.name">
                          <template slot="append">kwh</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="流量" class="item">
                        <el-input v-model="form.name">
                          <template slot="append">m³/h</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="4">
                      <el-form-item label="拖动方式" class="item">
                        <el-select v-model="tipData" placeholder="请选择">
                          <el-option
                            v-for="item in tipArray"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-col>
                </el-row>
                <el-row v-for="(items , index) in form.airArray" :key="index">
                  <el-col :span="24">
                    <el-col :span="1">
                      <el-form-item label="">
                      </el-form-item>
                    </el-col>
                    <!--<el-col :span="2">
                      <el-form-item :label="`机组${index + 1}`" class="item">
                      </el-form-item>
                    </el-col>-->
                    <el-col :span="5">
                      <el-form-item label="类型" class="item">
                        <el-select v-model="items.tipData" placeholder="请选择">
                          <el-option
                            v-for="item in tipArray"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="品牌" class="item">
                        <el-input v-model="items.name">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="型号" class="item">
                        <el-input v-model="items.name">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="冷量" class="item">
                        <el-input v-model="items.name">
                          <template slot="append">m³/h</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="1">
                      <el-form-item label="" class="item">
                        <i class="el-icon-delete" style="cursor: pointer" @click="deleteItem(items, index)"></i>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-col>
                </el-row>
              </el-form>
            </el-col>
          </el-row>
        </div>
        <div style="border-top: 1px solid #e8e8e8;width: 100%;height: 1px"></div>
        <div style="width: 100%;margin-top: 10px">
          <el-row>
            <el-col :span="2">
              <el-row>
                <el-col :span="24">
                  <div class="tool">
                    <el-popover
                      placement="bottom"
                      title=""
                      width="50"
                      trigger="click"
                    >
                      <!--// 品牌 型号 功率 流量 拖动方式 -->
                      <div style="text-align: center; margin: 0">
                        <el-button  size="mini" @click="addjizu" round>添加机组</el-button>
                      </div>
                      <el-button slot="reference"  size="mini">冷却塔</el-button>
                    </el-popover>
                  </div>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="18">
              <el-form ref="form" :model="form" label-width="100px" size="mini">
                <el-row >
                  <el-col :span="24">
                    <el-col :span="1">
                      <el-form-item label="">
                      </el-form-item>
                    </el-col>
                    <el-col :span="4">
                      <el-form-item label="品牌" class="item">
                        <el-input v-model="form.name">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="4">
                      <el-form-item label="型号" class="item">
                        <el-input v-model="form.name">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="功率" class="item">
                        <el-input v-model="form.name">
                          <template slot="append">kwh</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="流量" class="item">
                        <el-input v-model="form.name">
                          <template slot="append">m³/h</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="4">
                      <el-form-item label="拖动方式" class="item">
                        <el-select v-model="tipData" placeholder="请选择">
                          <el-option
                            v-for="item in tipArray"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-col>
                </el-row>
                <el-row v-for="(items , index) in form.airArray" :key="index">
                  <el-col :span="24">
                    <el-col :span="1">
                      <el-form-item label="">
                      </el-form-item>
                    </el-col>
                    <!--<el-col :span="2">
                      <el-form-item :label="`机组${index + 1}`" class="item">
                      </el-form-item>
                    </el-col>-->
                    <el-col :span="5">
                      <el-form-item label="类型" class="item">
                        <el-select v-model="items.tipData" placeholder="请选择">
                          <el-option
                            v-for="item in tipArray"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="品牌" class="item">
                        <el-input v-model="items.name">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="型号" class="item">
                        <el-input v-model="items.name">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="冷量" class="item">
                        <el-input v-model="items.name">
                          <template slot="append">m³/h</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="1">
                      <el-form-item label="" class="item">
                        <i class="el-icon-delete" style="cursor: pointer" @click="deleteItem(items, index)"></i>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-col>
                </el-row>
              </el-form>
            </el-col>
          </el-row>
        </div>
        <div style="border-top: 1px solid #e8e8e8;width: 100%;height: 1px"></div>
        <div style="width: 100%;margin-top: 10px">
          <el-row>
            <el-col :span="2">
              <el-row>
                <el-col :span="24">
                  <div class="tool">
                    <el-popover
                      placement="bottom"
                      title=""
                      width="50"
                      trigger="click"
                    >
                      <!--// 品牌 型号 功率 流量 拖动方式 -->
                      <div style="text-align: center; margin: 0">
                        <el-button  size="mini" @click="addjizu" round>添加机组</el-button>
                      </div>
                      <el-button slot="reference"  size="mini">换热器</el-button>
                    </el-popover>
                  </div>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="18">
              <el-form ref="form" :model="form" label-width="100px" size="mini">
                <el-row >
                  <el-col :span="24">
                    <el-col :span="1">
                      <el-form-item label="">
                      </el-form-item>
                    </el-col>
                    <el-col :span="4">
                      <el-form-item label="品牌" class="item">
                        <el-input v-model="form.name">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="4">
                      <el-form-item label="型号" class="item">
                        <el-input v-model="form.name">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="功率" class="item">
                        <el-input v-model="form.name">
                          <template slot="append">kwh</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="流量" class="item">
                        <el-input v-model="form.name">
                          <template slot="append">m³/h</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="4">
                      <el-form-item label="拖动方式" class="item">
                        <el-select v-model="tipData" placeholder="请选择">
                          <el-option
                            v-for="item in tipArray"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-col>
                </el-row>
                <el-row v-for="(items , index) in form.airArray" :key="index">
                  <el-col :span="24">
                    <el-col :span="1">
                      <el-form-item label="">
                      </el-form-item>
                    </el-col>
                    <!--<el-col :span="2">
                      <el-form-item :label="`机组${index + 1}`" class="item">
                      </el-form-item>
                    </el-col>-->
                    <el-col :span="5">
                      <el-form-item label="类型" class="item">
                        <el-select v-model="items.tipData" placeholder="请选择">
                          <el-option
                            v-for="item in tipArray"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="品牌" class="item">
                        <el-input v-model="items.name">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="型号" class="item">
                        <el-input v-model="items.name">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="冷量" class="item">
                        <el-input v-model="items.name">
                          <template slot="append">m³/h</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="1">
                      <el-form-item label="" class="item">
                        <i class="el-icon-delete" style="cursor: pointer" @click="deleteItem(items, index)"></i>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-col>
                </el-row>
              </el-form>
            </el-col>
          </el-row>
        </div>
        <div style="border-top: 1px solid #e8e8e8;width: 100%;height: 1px"></div>
        <div style="width: 100%;margin-top: 10px">
          <el-row>
            <el-col :span="2">
              <el-row>
                <el-col :span="24">
                  <div class="tool">
                    <el-popover
                      placement="bottom"
                      title=""
                      width="50"
                      trigger="click"
                    >
                      <!--// 品牌 型号 功率 流量 拖动方式 -->
                      <div style="text-align: center; margin: 0">
                        <el-button  size="mini" @click="addjizu" round>添加机组</el-button>
                      </div>
                      <el-button slot="reference"  size="mini">旁通阀</el-button>
                    </el-popover>
                  </div>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="18">
              <el-form ref="form" :model="form" label-width="100px" size="mini">
                <el-row >
                  <el-col :span="24">
                    <el-col :span="1">
                      <el-form-item label="">
                      </el-form-item>
                    </el-col>
                    <el-col :span="4">
                      <el-form-item label="品牌" class="item">
                        <el-input v-model="form.name">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="4">
                      <el-form-item label="型号" class="item">
                        <el-input v-model="form.name">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="功率" class="item">
                        <el-input v-model="form.name">
                          <template slot="append">kwh</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="流量" class="item">
                        <el-input v-model="form.name">
                          <template slot="append">m³/h</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="4">
                      <el-form-item label="拖动方式" class="item">
                        <el-select v-model="tipData" placeholder="请选择">
                          <el-option
                            v-for="item in tipArray"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-col>
                </el-row>
                <el-row v-for="(items , index) in form.airArray" :key="index">
                  <el-col :span="24">
                    <el-col :span="1">
                      <el-form-item label="">
                      </el-form-item>
                    </el-col>
                    <!--<el-col :span="2">
                      <el-form-item :label="`机组${index + 1}`" class="item">
                      </el-form-item>
                    </el-col>-->
                    <el-col :span="5">
                      <el-form-item label="类型" class="item">
                        <el-select v-model="items.tipData" placeholder="请选择">
                          <el-option
                            v-for="item in tipArray"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="品牌" class="item">
                        <el-input v-model="items.name">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="型号" class="item">
                        <el-input v-model="items.name">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="冷量" class="item">
                        <el-input v-model="items.name">
                          <template slot="append">m³/h</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="1">
                      <el-form-item label="" class="item">
                        <i class="el-icon-delete" style="cursor: pointer" @click="deleteItem(items, index)"></i>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-col>
                </el-row>
              </el-form>
            </el-col>
          </el-row>
        </div>
        <div style="border-top: 1px solid #e8e8e8;width: 100%;height: 1px"></div>
        <div style="width: 100%;margin-top: 10px">
          <el-row>
            <el-col :span="2">
              <el-row>
                <el-col :span="24">
                  <div class="tool">
                    <el-popover
                      placement="bottom"
                      title=""
                      width="50"
                      trigger="click"
                    >
                      <!--// 品牌 型号 功率 流量 拖动方式-->
                      <div style="text-align: center; margin: 0">
                        <el-button  size="mini" @click="addjizu" round>添加机组</el-button>
                      </div>
                      <el-button slot="reference"  size="mini">旁通阀</el-button>
                    </el-popover>
                  </div>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="18">
              <el-form ref="form" :model="form" label-width="100px" size="mini">
                <el-row >
                  <el-col :span="24">
                    <el-col :span="1">
                      <el-form-item label="">
                      </el-form-item>
                    </el-col>
                    <el-col :span="4">
                      <el-form-item label="品牌" class="item">
                        <el-input v-model="form.name">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="4">
                      <el-form-item label="型号" class="item">
                        <el-input v-model="form.name">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="功率" class="item">
                        <el-input v-model="form.name">
                          <template slot="append">kwh</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="流量" class="item">
                        <el-input v-model="form.name">
                          <template slot="append">m³/h</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="4">
                      <el-form-item label="拖动方式" class="item">
                        <el-select v-model="tipData" placeholder="请选择">
                          <el-option
                            v-for="item in tipArray"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-col>
                </el-row>
                <el-row v-for="(items , index) in form.airArray" :key="index">
                  <el-col :span="24">
                    <el-col :span="1">
                      <el-form-item label="">
                      </el-form-item>
                    </el-col>
                    <!--<el-col :span="2">
                      <el-form-item :label="`机组${index + 1}`" class="item">
                      </el-form-item>
                    </el-col>-->
                    <el-col :span="5">
                      <el-form-item label="类型" class="item">
                        <el-select v-model="items.tipData" placeholder="请选择">
                          <el-option
                            v-for="item in tipArray"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="品牌" class="item">
                        <el-input v-model="items.name">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="型号" class="item">
                        <el-input v-model="items.name">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="冷量" class="item">
                        <el-input v-model="items.name">
                          <template slot="append">m³/h</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="1">
                      <el-form-item label="" class="item">
                        <i class="el-icon-delete" style="cursor: pointer" @click="deleteItem(items, index)"></i>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-col>
                </el-row>
              </el-form>
            </el-col>
          </el-row>
        </div>
        <div style="border-top: 1px solid #e8e8e8;width: 100%;height: 1px"></div>
        <div style="width: 100%;margin-top: 10px">
          <el-row>
            <el-col :span="2">
              <el-row>
                <el-col :span="24">
                  <div class="tool">
                    <el-popover
                      placement="bottom"
                      title=""
                      width="50"
                      trigger="click"
                    >
                      <!--// 品牌 型号 功率 流量 拖动方式-->
                      <div style="text-align: center; margin: 0">
                        <el-button  size="mini" @click="addjizu" round>添加机组</el-button>
                      </div>
                      <el-button slot="reference"  size="mini">分机水器</el-button>
                    </el-popover>
                  </div>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="18">
              <el-form ref="form" :model="form" label-width="100px" size="mini">
                <el-row >
                  <el-col :span="24">
                    <el-col :span="1">
                      <el-form-item label="">
                      </el-form-item>
                    </el-col>
                    <el-col :span="4">
                      <el-form-item label="品牌" class="item">
                        <el-input v-model="form.name">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="4">
                      <el-form-item label="型号" class="item">
                        <el-input v-model="form.name">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="功率" class="item">
                        <el-input v-model="form.name">
                          <template slot="append">kwh</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="流量" class="item">
                        <el-input v-model="form.name">
                          <template slot="append">m³/h</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="4">
                      <el-form-item label="拖动方式" class="item">
                        <el-select v-model="tipData" placeholder="请选择">
                          <el-option
                            v-for="item in tipArray"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-col>
                </el-row>
                <el-row v-for="(items , index) in form.airArray" :key="index">
                  <el-col :span="24">
                    <el-col :span="1">
                      <el-form-item label="">
                      </el-form-item>
                    </el-col>
                    <!--<el-col :span="2">
                      <el-form-item :label="`机组${index + 1}`" class="item">
                      </el-form-item>
                    </el-col>-->
                    <el-col :span="5">
                      <el-form-item label="类型" class="item">
                        <el-select v-model="items.tipData" placeholder="请选择">
                          <el-option
                            v-for="item in tipArray"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="品牌" class="item">
                        <el-input v-model="items.name">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="型号" class="item">
                        <el-input v-model="items.name">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="5">
                      <el-form-item label="冷量" class="item">
                        <el-input v-model="items.name">
                          <template slot="append">m³/h</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="1">
                      <el-form-item label="" class="item">
                        <i class="el-icon-delete" style="cursor: pointer" @click="deleteItem(items, index)"></i>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-col>
                </el-row>
              </el-form>
            </el-col>
          </el-row>
        </div>
      </div>
       <!--数量 备注  -->
       <!--空调方式 下拉  品牌 型号  功率 数量 电机功率 控制方式-->
       <!--暖气  阀门 数量 管径-->
       <!-- vrv  品牌 型号  功率 数量 电机功率 控制方式-->
      <!-- 换气方式  选择  风孔 -->
      <!-- 照明 多选 开关控制  调光控制 ， 灯具数量 回路数 -->
      <!-- 门形式（+） 门锁数量-->
      <!-- 窗帘（单选） -->
      <div style="border-top: 1px solid #e8e8e8;width: 100%;height: 1px"></div>
      <div style="width: 99%;height: 42%">
        <span>控制组件配置清单</span>
       <el-row :gutter="50" type="flex"  style="min-height: 100%;">
         <el-col :span="15">
           <div style="width: 100%;height: 100%;overflow: hidden">
             <el-table
               :data="tableData"
               border
               style="width: 100%">
               <el-table-column
                 prop="xuhao"
                 label="序号"
                 width="50">
               </el-table-column>
               <el-table-column
                 prop="name"
                 label="设备名称"
                 width="180">
               </el-table-column>
               <el-table-column
                 prop="model"
                 label="产品型号"
                 width="180">
               </el-table-column>
               <el-table-column
                 prop="number"
                 label="数量"
                 width="70">
               </el-table-column>
               <el-table-column
                 prop="parameter"
                 label="主要技术参数">
               </el-table-column>
             </el-table>
           </div>
         </el-col>
         <el-col :span="9">
           <div style="width: 100%;height: 100%;overflow: hidden">
             <el-row>
               <el-col :span="3" style="margin-top: 1.3%">
                 <span style="font-size: 1vh">控制程序:</span>
               </el-col>
               <el-col :span="15">
                 <div style="border-top: 1px solid #4847be;width: 100%;height: 1px;margin-top: 8%"></div>
               </el-col>
               <el-col :span="6">
                 <div class="toolbt"> <el-button size="mini" type="primary"  @click="generate" style="margin-left: 5%">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;数据表&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</el-button></div>
               </el-col>
             </el-row>
             <el-row style="margin-top: 4%">
               <el-col :span="3" style="margin-top: 1.3%">
                 <span style="font-size: 1vh">接线图:</span>
               </el-col>
               <el-col :span="15">
                 <div style="border-top: 1px solid #4847be;width: 100%;height: 1px;margin-top: 8%"></div>
               </el-col>
               <el-col :span="6">
                 <div class="toolbt"> <el-button size="mini" type="primary" style="margin-left: 5%">&nbsp;&nbsp;&nbsp;&nbsp;标准图库&nbsp;&nbsp;&nbsp;</el-button></div>
               </el-col>
             </el-row>
             <el-row style="margin-top: 4%">
               <el-col :span="3" style="margin-top: 1.3%">
                 <span style="font-size: 1vh">控制原理图:</span>
               </el-col>
               <el-col :span="15">
                 <div style="border-top: 1px solid #4847be;width: 100%;height: 1px;margin-top: 8%"></div>
               </el-col>
               <el-col :span="6">
                 <div class="toolbt"> <el-button size="mini" type="primary" style="margin-left: 5%">控制方案说明</el-button></div>
               </el-col>
             </el-row>
             <el-row style="margin-top: 4%">
               <el-col :span="5" style="margin-top: 1.3%">
                 <span style="font-size: 1vh">设备监控界面模板:</span>
               </el-col>
               <el-col :span="13">
                 <div style="border-top: 1px solid #4847be;width: 100%;height: 1px;margin-top: 8%"></div>
               </el-col>
               <el-col :span="6">
                 <div class="toolbt"> <el-button size="mini" type="primary" style="margin-left: 5%">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;模板库&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</el-button></div>
               </el-col>
             </el-row>
           </div>
         </el-col>
       </el-row>
      </div>
      <div style="border-top: 1px solid #e8e8e8;width: 100%;height: 1px"></div>
    </div>
</template>
<script>
import echarts from 'echarts'
import authorityService from '../../service/authorityService'
export default {
  name: '',
  components: {
    collapse: false
  },
  data () {
    return {
      visible:false,
      name:'',
      form: {
        name: '',
        airArray:[],
      },
      tipArray:[
        {
          value: '活塞式',
          label: '活塞式'
        }, {
          value: '螺杆式',
          label: '螺杆式'
        }, {
          value: '离心式',
          label: '离心式'
        }
      ],
      tipData:'',
      tableData:[],
    }
  },
  computed: {
  },
  mounted () {
  },
  methods: {
    onSubmit() {
      console.log('submit!');
    },
    // 生成控制方案
    generate(){
      this.tableData = [{
        xuhao:'1',
        name:'送风机',
        model:'BAC-4KW',
        number:'1',
        parameter:'包含智能仪表、热继、交流接触器、空开、保险等'
      },{
        xuhao:'2',
        name:'回风机',
        model:'BACS-4KW',
        number:'1',
        parameter:'包含变频器、空开、保险等'
      },{
        xuhao:'3',
        name:'湿膜加湿',
        model:'DN=100',
        number:'1',
        parameter:'根据送风湿度与设定湿度的差值控制加湿阀，达到加湿的效果。'
      },{
        xuhao:'4',
        name:'新风阀',
        model:'',
        number:'1',
        parameter:'新风阀与送风机联动；根据回风CO2浓度PID调节新风阀开度，保证室内空气新鲜和舒适。'
      },{
        xuhao:'5',
        name:'回风阀',
        model:'',
        number:'1',
        parameter:'回风阀与新风阀开度互补，保证新风阀开度与回风阀开度的和为100%。'
      },{
        xuhao:'6',
        name:'排风阀',
        model:'',
        number:'1',
        parameter:'排风阀开度与新风阀开度保持一致，'
      }]
    },
    // 添加新机组按钮
    addjizu(){
      this.form.airArray.push({
        name:'',
        tipData:'',
      })
    },
    // 删除新增机组
    deleteItem(items, index){
      this.form.airArray.splice(index, 1)
    }
  }
}
</script>
<style scoped>
  .toolbt>>>.el-button{
    background-color: #409eff;
    color: white;
  }
  .tool>>>.el-button{
    background-color: #ffffff;
  }
  .desig-main{
    width: 100%;
    height: 100%;
    font-size: 15px;
  }  .information-content{width: 100%;height: 100%;}
  .file-content{
    width: 100%;
  }
  .tit-content{
    font-size: 1.5vh;
    font-family: 宋体;
    font-weight: 600;
  }
  .information-content>>> .item .el-form-item__label{
    font-size: 1vh;
  }
  .information-content>>>.el-input-group__append, .el-input-group__prepend{
    padding: 0 7px;
  }
</style>
<style>
  .el-table--enable-row-hover .el-table__body tr:hover>td {
    background-color: #48adff;
  }
  .el-table__header tr,
  .el-table__header th {
    padding: 0;
    height: 32px;
  }
  .el-table__body tr,
  .el-table__body td {
    padding: 0;
    height: 27px;
  }
  .el-input__inner {
    height: 26px;
    border-radius: 0px;
    font-size: 1vh;
    color:#606266;
  }
  .el-table .cell {
    padding-left: 0px;
    padding-right: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Toolmain/refrigeration.vue